export interface ConvocatoriaJuradosModel {
  nombre_convocatoria: string;
  area: Array<any>;
  cobertura: string;
  entidad: string;
  funciones_principales: string;
  tipo_participante: Array<any>;
  tipo: number;
  portada_url?:string,
  descripcion_corta: string,
  objetivo: string;
  noparticipa: string;
  perfil_participante: string;
}

export const initialValuesConvocatoriaJurados = {
  nombre_convocatoria: "",
  area: [],
  cobertura: "",
  funciones_principales: "",
  tipo_participante: [],
  entidad: "",
  tipo: 2,
  portada_url: "",
  descripcion_corta: "",
  objetivo: "",
  noparticipa: "",
  perfil_participante: ""
};
